import { useConfigStore } from '@/stores/config'
export default defineNuxtPlugin(async nuxtApp => {
  const configStore = useConfigStore()
  configStore.initConfig

  // Avoid duplicate calls on client-side routing
  if (!configStore.environments.length) {
    await configStore.fetchDataEnvironment()
  }
  if (!configStore.inventorySources.length) {
    await configStore.fetchDataInventorySources()
  }

  if (!configStore.vendors.length) {
    await configStore.fetchDataVendors()
  }
})
